import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLocalContext } from "../../context/LocalContext";
import { resolveSiteEmail, resolveSiteName, resolveSitePhone } from "../../utils/siteConfig";
import "./Contact.css";

const Contact = () => {
  const { webinfo = {} } = useLocalContext();
  const phoneCall = webinfo?.phonecall || "";
  const phoneText = resolveSitePhone(webinfo) || webinfo?.phonecall || "Call us";
  const email = resolveSiteEmail(webinfo);
  const brand = resolveSiteName(webinfo);
  const [loading, setLoading] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      alert("Thanks! Your message has been received. We’ll reply soon.");
      e.target.reset();
    }, 600);
  };

  return (
    <section className="contact" aria-label="Contact">
      <div className="contact__wrap">
        <motion.div
          className="contact__head"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65 }}
        >
          <p className="contact__tag">Contact</p>
          <h1 className="contact__title">Tell us what’s stuck — we’ll help you finish.</h1>
          <p className="contact__sub">
            Share your device brand, model, and the issue. {brand} will point you to the right flow or a specialist.
          </p>
        </motion.div>

        <div className="contact__grid">
          <aside className="contact__card">
            <h2>Reach us</h2>
            <p>
              <a href={`mailto:${email}`}>{email}</a>
            </p>
            {phoneText && (
              <p>
                <a href={phoneCall ? `tel:${phoneCall}` : "#"}>{phoneText}</a>
              </p>
            )}
            <div className="contact__quick">
              <a href="/printlab">Printer setup →</a>
              <a href="/wavelab">Extender help →</a>
            </div>
          </aside>

          <form className="contact__form" onSubmit={onSubmit}>
            <label>
              Name
              <input name="name" required placeholder="Your name" />
            </label>
            <label>
              Phone
              <input name="phone" required placeholder="Best number to reach you" />
            </label>
            <label>
              Device / brand
              <input name="brand" placeholder="e.g. HP DeskJet, TP-Link RE450" />
            </label>
            <label>
              What’s going wrong?
              <textarea name="message" rows="4" required placeholder="Offline printer, extender not pairing, error code…" />
            </label>
            <button type="submit" disabled={loading}>
              {loading ? "Sending…" : "Send message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
